import { Alert } from '@mui/material';
import { SUPPORT_SESSION_KEY } from '@/pages/auth/SupportLoginPage';

/** Shown on every screen while TravelERP support is signed in with the company's consent. */
export default function SupportSessionBanner() {
  let active = false;
  try { active = window.sessionStorage.getItem(SUPPORT_SESSION_KEY) === '1'; } catch { /* private mode */ }
  if (!active) return null;
  return (
    <Alert severity="warning" sx={{ mb: 2 }}>
      <strong>Support session.</strong> TravelERP support is signed in to this workspace with the company's consent.
      Everything done here is recorded.
    </Alert>
  );
}
